module.exports = __webpack_public_path__ + "assets/img/addTask_btn3.e2ee5553.png";